export default __webpack_public_path__ + "media/application/assets/images/signing-instructions/2WitANDNotary-NOTARY-5ee1c2ff79ac1238ad3f98f83eb8a653.PNG";